class ZusammenKaufenBootstrap extends HTMLElement {
    connectedCallback() {
        // Die Komponente <zusammen-kaufen> kommt aus dem EmpfehlungenOCS zusammen mit der Response des
        // "Andere Kunden interessierte auch" Slider. Das CustomEvent wird beim connectedCallback gefeuert.
        // Wir reagieren hier auf das Event und laden das HTML in dieser Bootstrap Komponente.
        document.addEventListener('zusammen-kaufen-geladen', (event) => {
            event.detail.html.setAttribute('data-state', 'rendered');
            event.detail.html.removeAttribute('hidden');
            this.insertAdjacentElement('beforeend', event.detail.html);
        });
    }
}

if (!customElements.get("zusammen-kaufen-bootstrap")) {
    customElements.define("zusammen-kaufen-bootstrap", ZusammenKaufenBootstrap);
}
